import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
// import classnames from "classnames";
import { DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import { withStyles, Grid, Divider, Button, CircularProgress, LinearProgress } from '@material-ui/core';
import { AppContext } from '../../../AppContext';
import { OrderDetailContext } from '../OrderDetailContext';
import { ConfirmationDialog } from '../../ConfirmationDialog';
import { getOrderCancellationReasons } from '../../../services';
import { Autocomplete } from '../../Autocomplete';
import AsyncSelect from '../../DynamicForm/FormInputs/Select/AsyncSelect';
import cn from 'classnames';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import FormInput from '../../ReactHookForm/FormInput/FormInput';
import SectionHeader from '../../ReactHookForm/SectionHeader';
import ROLES, { hasPermission } from '../../../helpers/roles';

// SERVICES
import {
  getClientList,
  getInspectors,
  getInspectorsOptions,
  updateOrderLine,
  cancelOrderLine,
  convertOrderLineToSelfInspect,
  getValidOrdersForInspector,
} from '../../../services';

const styles = theme => ({});

export const SELF_INSPECT_FORM_FIELDS = {
  EMAIL: 'email',
  CONFIRM_EMAIL: 'confirmEmail',
};

const selfInspectFormValidationSchema = Yup.object().shape({
  [SELF_INSPECT_FORM_FIELDS.EMAIL]: Yup.string()
    .email('Email is not valid')
    .default('')
    .required('Email is required'),
  [SELF_INSPECT_FORM_FIELDS.CONFIRM_EMAIL]: Yup.string()
    .email('Email is not valid')
    .default('')
    .oneOf([Yup.ref(SELF_INSPECT_FORM_FIELDS.EMAIL)], 'Emails do not match!')
    .required('Confirmation email is required'),
});

const selfInspectDefaultValues = {
  [SELF_INSPECT_FORM_FIELDS.EMAIL]: '',
  [SELF_INSPECT_FORM_FIELDS.CONFIRM_EMAIL]: '',
};

export const OrderDetailDetailTab = withStyles(styles)(({ classes, orderLineId, fetchOrderData }) => {
  const {
    state: { username, roles },
    dispatch,
  } = useContext(AppContext);
  const {
    state: { detail: detailData },
  } = useContext(OrderDetailContext);

  // Permission checks
  const isCallCenter = hasPermission([ROLES.CALLCENTER], roles);
  const canCancelOrder = hasPermission([ROLES.ADMIN, ROLES.CALLCENTER], roles);
  const canEditOrder = !isCallCenter;

  const [clientList, setClientList] = useState([]);
  const [inspectorList, setInspectorList] = useState([]);
  const [isCancelingOrder, setIsCancelingOrder] = useState(false);
  const [isConvertingOrder, setIsConvertingOrder] = useState(false);
  const [canceledOrderMessage, setCanceledOrderMessage] = useState(null);
  const [convertedOrderMessage, setConvertedOrderMessage] = useState(null);
  const [cancelDialogVisible, setCancelDialogVisible] = useState(false);
  const [selfInspectDialogVisible, setSelfInspectDialogVisible] = useState(false);
  const [selectedCancellationReasonOption, setSelectedCancellationReasonOption] = useState(null);
  const [cancellationReasonOptions, setCancellationReasonOptions] = useState([]);
  const [cancelComment, setCancelComment] = useState('');
  const [userRestrictedOrderLineIdMessage, setUserRestrictedOrderLineIdMessage] = useState(null);
  const [validatingOrders, setValidatingOrders] = useState(false);
  const [selfInspectForm, setSelfInspectForm] = useState({
    email: '',
    confirmEmail: '',
  });

  const selfInspectFormMethods = useForm({
    resolver: yupResolver(selfInspectFormValidationSchema),
    reValidateMode: 'onSubmit',
    defaultValues: selfInspectDefaultValues,
  });

  const detailInputs = [
    // CONTAINER
    {
      inputType: 'gridcontainer',
      children: [
        // ITEM
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'custom',
              field: 'inspectorId',
              label: 'Inspector ID',
              validate: [],
              customComponent: (
                <AsyncSelect
                  isMutli
                  defaultValue={detailData?.inspectorId}
                  fetchOptions={getInspectorsOptions}
                  queryParamDefaultKey={'inspectorId'}
                  disabled={false}
                />
              ),
              onChange: val => {
                if (canEditOrder) {
                  getValidOrdersForInspectorAsync(val);
                }
              },
            },
            {
              inputType: 'text',
              field: 'reportName',
              label: 'Report Type',
              disabled: true,
              validate: [],
            },
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'object',
                field: 'client',
                child: {
                  inputType: 'text',
                  field: 'name',
                  label: 'Client Name',
                  disabled: true,
                  // inputType: 'select',
                  // field: 'id',
                  // label: 'Client Name',
                  // validate: [v.required()],
                  // options: clientList,
                },
              },
            },
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'object',
                field: 'agentMaster',
                child: {
                  inputType: 'text',
                  field: 'agentName',
                  label: 'Agent Name',
                  disabled: true,
                },
              },
            },
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'object',
                field: 'agentMaster',
                child: {
                  inputType: 'text',
                  field: 'agentPhone',
                  label: 'Agent Phone',
                  disabled: true,
                },
              },
            },

            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'object',
                field: 'agentMaster',
                child: {
                  inputType: 'text',
                  field: 'agentEmail',
                  label: 'Agent Email',
                  disabled: true,
                },
              },
            },

            {
              inputType: 'object',
              field: 'importLine',
              child: {
                inputType: 'text',
                field: 'agentcontactname',
                label: 'Agent Contact Name',
                disabled: true,
              },
            },

            {
              inputType: 'object',
              field: 'importLine',
              child: {
                inputType: 'text',
                field: 'agentcontactphone',
                label: 'Agent Contact Phone',
                disabled: true,
              },
            },

            {
              inputType: 'object',
              field: 'importLine',
              child: {
                inputType: 'text',
                field: 'agentcontactemail',
                label: 'Agent Contact Email',
                disabled: true,
              },
            },

            {
              inputType: 'text',
              field: 'orderTicket',
              label: 'Order Ticket',
              disabled: true,
              validate: [],
            },

            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'object',
                field: 'policyHolder',
                child: {
                  inputType: 'text',
                  field: 'fname',
                  label: 'PH First Name',
                  disabled: true,
                  validate: [],
                },
              },
            },
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'object',
                field: 'policyHolder',
                child: {
                  inputType: 'text',
                  field: 'lname',
                  label: 'PH Last Name',
                  disabled: true,
                  validate: [],
                },
              },
            },

            {
              inputType: 'object',
              field: 'importLine',
              child: {
                inputType: 'text',
                field: 'insuredphone1',
                label: 'Insured Phone',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'importLine',
              child: {
                inputType: 'text',
                field: 'insuredEmail',
                label: 'Insured Email',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'importLine',
              child: {
                inputType: 'text',
                field: 'customerreferenceno',
                label: 'Customer Reference Number ',
                disabled: true,
              },
            },
          ],
        },

        // ITEM
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'date',
              field: 'orderDate',
              label: 'Order Date',
              disabled: true,
              validate: [],
            },
            {
              inputType: 'date',
              field: 'inspectorClosedDate',
              label: 'Inspector Closed Date',
              disabled: true,
              validate: [],
            },
            {
              inputType: 'date',
              field: 'dueDate',
              label: 'Due Date',
              disabled: !canEditOrder,
              validate: [],
            },

            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'ad1',
                label: 'Address',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'ad2',
                label: 'Address 2',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'ad3',
                label: 'Address 3',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'city',
                label: 'City',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'st',
                label: 'State',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'zip',
                label: 'Zip',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policyHolderAddress',
              child: {
                inputType: 'text',
                field: 'plus4',
                label: 'Zip Ext.',
                disabled: true,
                validate: [],
              },
            },
          ],
        },
      ],
    },

    // CONTAINER
    {
      inputType: 'gridcontainer',
      children: [
        // ITEM
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'text',
                field: 'policyNumber',
                label: 'Policy Number',
                disabled: true,
                validate: [],
              },
            },
            {
              inputType: 'text',
              field: 'invisionLink',
              label: 'Self-Inspect Link',
              disabled: true,
              validate: [],
            },
          ],
        },

        // ITEM
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'date',
                disabled: true,
                field: 'policyEffectiveDate',
                label: 'Effective Date',
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'date',
                disabled: true,
                field: 'policyExpirationDate',
                label: 'Expiration Date',
                validate: [],
              },
            },
            {
              inputType: 'object',
              field: 'policy',
              child: {
                inputType: 'date',
                disabled: true,
                field: 'policyRenewDate',
                label: 'Renew Date',
                validate: [],
              },
            },
          ],
        },
      ],
    },
  ];

  const getValidOrdersForInspectorAsync = async inspectorId => {
    setValidatingOrders(true);
    const validOrderLineIds = await getValidOrdersForInspector(inspectorId);
    const invalidOrderLineId = !validOrderLineIds.includes(parseInt(orderLineId));
    if (invalidOrderLineId) {
      setUserRestrictedOrderLineIdMessage(
        `Warning: The selected inspector is typically restricted from assignment on this type of order. If you save, the restriction will be removed for this order and it will be assigned to the selected inspector.`,
      );
    } else {
      setUserRestrictedOrderLineIdMessage(null);
    }
    setValidatingOrders(false);
  };

  const handleCancelOrder = async () => {
    setIsCancelingOrder(true);
    setCanceledOrderMessage(null);

    try {
      const result = await cancelOrderLine(detailData.id, selectedCancellationReasonOption.value, cancelComment);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: result.message,
          variant: result.success ? 'success' : 'error',
        },
      });
      fetchOrderData();
      setCancelDialogVisible(false);
    } catch (error) {
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: error.message || 'Something happened during cancellation',
          variant: 'error',
        },
      });
    } finally {
      setIsCancelingOrder(false);
    }
  };

  const onSelfInspectSubmitInvalid = async errors => {
    console.log('invalid', errors);
  };
  const onSelfInspectSubmitValid = async form => {
    // convert FORM_FIELDS.IMPORT_VERIFICATION_EMAIL back to string
    const finalForm = {
      ...form,
      orderLineId: detailData.id,
    };

    console.log(finalForm);

    try {
      // await new Promise(resolve => setTimeout(resolve, 3000));

      const result = await convertOrderLineToSelfInspect(finalForm);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: result.message,
          variant: result.success ? 'success' : 'error',
        },
      });

      fetchOrderData();
      setSelfInspectDialogVisible(false);
      selfInspectFormMethods.reset(selfInspectDefaultValues);
    } catch (error) {
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: error.message || 'Something happened during convert to self inspection',
          variant: 'error',
        },
      });
    }
  };

  useEffect(() => {
    const getOrderCancellationReasonsAsync = async () => {
      try {
        let cancellationReasons = await getOrderCancellationReasons();
        cancellationReasons = cancellationReasons.map(cr => ({
          value: cr.cancellationReasonId,
          label: cr.name,
        }));
        setCancellationReasonOptions(cancellationReasons);
      } catch (error) {
        console.log(error);
      }
    };

    const getClientListAsync = async () => {
      let clients = await getClientList();
      clients = clients.map(c => {
        return {
          value: c.id,
          label: `${c.name} ${c.code && `(${c.code})`}`,
        };
      });
      setClientList(clients);
    };
    // const getInspectorsAsync = async () => {
    //   let inspectors = await getInspectorsOptions({});
    //   setInspectorList(inspectors);
    // };

    getClientListAsync();
    // getInspectorsAsync();
    getOrderCancellationReasonsAsync();
    fetchOrderData();

    // const crumbs = props.location.pathname.split('/').slice(1)
    // setBreadcrumbs(crumbs);
  }, []);

  return (
    <div>
      <div className={cn('row-between-center')}>
        {!!detailData && (
          <div>
            {!!detailData.orderLineStatusLookup && (
              <div>
                <span style={{ fontWeight: 'bold' }}>Status:</span> {detailData.orderLineStatusLookup.descript}
              </div>
            )}
            {/* {!!detailData.orderState && <div>Order State: {detailData.orderState.name}</div>} */}
          </div>
        )}
        {detailData && (detailData.orderStateId === 5 || detailData.orderStateId === 6) && (
          <div style={{ color: 'red' }}>HOLD</div>
        )}
        {// make sure the user is admin and the order is not already canceled or completed
        // OrderStateId: 4 = CANCELLED
        // OrderLineStatusLookupId: 8, 9, 10 = QA-COMPPLETED, CL-DELIVERED, CL-ACCEPTED
        canCancelOrder &&
          detailData &&
          detailData.orderStateId !== 4 &&
          ![8, 9, 10].includes(detailData.orderLineStatusLookupId) && (
            <div className={cn('row-between-center')} style={{ gap: '10px' }}>
              {/* <Button
                variant="contained"
                style={{ backgroundColor: '#F44336', color: 'white' }}
                onClick={() => setSelfInspectDialogVisible(true)}
              >
                Create Self Inspection
              </Button> */}
              <Button
                variant="contained"
                style={{ backgroundColor: '#F44336', color: 'white' }}
                onClick={() => setCancelDialogVisible(true)}
              >
                Cancel Order
              </Button>
            </div>
          )}

        {detailData && detailData.orderStateId === 4 && <div style={{ color: 'red' }}>CANCELLED</div>}
      </div>
      {userRestrictedOrderLineIdMessage && (
        <p
          style={{
            color: 'red',
            fontWeight: 'bold',
          }}
        >
          {userRestrictedOrderLineIdMessage}
        </p>
      )}
      
      {validatingOrders && (
        <div className="mb-20">
          <div className="text-center">Validating...</div>
          <LinearProgress />
        </div>
      )}
      <DynamicForm 
        inputs={detailInputs} 
        mode={ 'EDIT'} 
        data={detailData} 
        onSave={updateOrderLine } 
      />

      <ConfirmationDialog
        visible={cancelDialogVisible}
        setVisibility={setCancelDialogVisible}
        title={'Order Cancellation'}
        disabled={isCancelingOrder}
        isSubmitting={isCancelingOrder}
        submitMessage={canceledOrderMessage}
        cancelButton={
          <Button
            disabled={isCancelingOrder}
            onClick={() => setCancelDialogVisible(false)}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white', opacity: isCancelingOrder ? 0.5 : 1 }}
          >
            No
          </Button>
        }
        acceptButton={
          <Button
            disabled={isCancelingOrder || !selectedCancellationReasonOption}
            onClick={handleCancelOrder}
            variant="contained"
            style={{
              backgroundColor: '#F44336',
              color: 'white',
              opacity: isCancelingOrder || !selectedCancellationReasonOption ? 0.5 : 1,
            }}
          >
            Yes, cancel this order
          </Button>
        }
      >
        <div>Are you sure you want to cancel order #{orderLineId}?</div>

        <div style={{ marginTop: 35 }}>Why is this order being canceled?</div>
        <Autocomplete
          options={cancellationReasonOptions}
          value={selectedCancellationReasonOption}
          onChange={setSelectedCancellationReasonOption}
          placeholder={'Please select a cancellation reason'}
          // error={}
          // hideLabel={true}
        />

        <div style={{ marginTop: 35 }}>Add any additional information that was not asked about here:</div>
        <textarea
          value={cancelComment}
          onChange={evt => setCancelComment(evt.target.value)}
          style={{ marginTop: 10, width: '100%' }}
          rows={10}
        />
      </ConfirmationDialog>

      <ConfirmationDialog
        visible={selfInspectDialogVisible}
        setVisibility={setSelfInspectDialogVisible}
        title={'Convert to Self Inspection'}
        // isSubmitting={selfInspectFormMethods.formState.isSubmitting}
        disabled={selfInspectFormMethods.formState.isSubmitting}
        submitMessage={convertedOrderMessage}
        minHeight={100}
        cancelButton={
          <Button
            disabled={selfInspectFormMethods.formState.isSubmitting}
            onClick={() => setSelfInspectDialogVisible(false)}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white', opacity: isConvertingOrder ? 0.5 : 1 }}
          >
            Cancel
          </Button>
        }
        acceptButton={
          <Button
            disabled={selfInspectFormMethods.formState.isSubmitting}
            onClick={selfInspectFormMethods.handleSubmit(onSelfInspectSubmitValid, onSelfInspectSubmitInvalid)}
            variant="contained"
            style={{
              backgroundColor: '#F44336',
              color: 'white',
              opacity: selfInspectFormMethods.formState.isSubmitting ? 0.5 : 1,
            }}
          >
            {selfInspectFormMethods.formState.isSubmitting ? (
              <>
                <CircularProgress style={{ fill: '#fff', color: '#fff', marginRight: 10 }} size={25} />
                Converting
              </>
            ) : (
              'Yes, convert to self inspection'
            )}
          </Button>
        }
      >
        <div style={{ marginBottom: 24, textAlign: 'center' }}>
          Please enter an email for the policy holder. They will receive an email with a link to start the self
          inspection?
        </div>

        <FormProvider {...selfInspectFormMethods} schema={selfInspectFormValidationSchema}>
          <Grid
            //
            container
            direction="row"
            className={cn(classes.gridContainer)}
            spacing={2}
          >
            {/* <SectionHeader title="Client" /> */}

            <Grid item xs={6}>
              <FormInput
                //
                type="text"
                name={SELF_INSPECT_FORM_FIELDS.EMAIL}
                label="Policy Holder Email"
              />
            </Grid>
            <Grid item xs={6}>
              <FormInput
                type="text"
                name={SELF_INSPECT_FORM_FIELDS.CONFIRM_EMAIL}
                label="Confirm Policy Holder Email"
              />
            </Grid>
          </Grid>
        </FormProvider>
      </ConfirmationDialog>
    </div>
  );
});

OrderDetailDetailTab.propTypes = {};
OrderDetailDetailTab.defaultProps = {};
